import React, { createContext, useState } from "react"

const ModalContext = createContext({})

const ModalProvider = ({ children }) => {
  const [modalIsOpen, setModalIsOpen] = useState(false)
  const [loading /*, setLoading*/] = useState(true)
  const [modalData, setModalData] = useState({})

  const openModal = ( data ) => {
    setModalData( data )
    setModalIsOpen( true )
  }

  const closeModal = () => {
    setModalIsOpen(false)
  }

  return (
    <ModalContext.Provider
      value={{
        loading,
        modalIsOpen,
        modalData,
        openModal,
        closeModal,
      }}
    >
      {children}
    </ModalContext.Provider>
  )
}

export { ModalContext, ModalProvider }
